import { userService } from "../services";
import config from "../config/config";

export const LoginAction = {
  fetchLoginData,
  logOutAndClearToken,
};

async function fetchLoginData(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.loginApi}`;
    let response = await userService.loginService(apiEndpoint, payload);
    debugger;
    if (response && response?.status == 200) {
      return response?.data;
    } else {
      console.log(response);
      showSnackbar(response?.data?.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function logOutAndClearToken(showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.logOut}`;
    let response = await userService.post(apiEndpoint, {});

    if (response && response?.status === 200) {
      return response?.data;
    } else {
      showSnackbar(response?.data?.message || "Logout failed", "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
